import "shared/styles/Home.css";

import React, {useCallback} from "react";
import {Link, useNavigate} from 'react-router-dom';

import {authService, useAuth} from "features/auth";

const Header = ({help, logOut}: { logOut: boolean, help: boolean }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const logOutCallback = useCallback(async () => {
        await authService.logOut();
        logout();
    }, [logout]);

    const getHelp = useCallback(() => {
        navigate('/user-guide');
    }, [navigate]);
    
    return (
        <header>
            <Link style={{textDecoration: "unset"}} to="/"><h2 className="subheading">Validation Ruler</h2></Link>
            <div className="btn-container">
                {help? <button className="button green-button" onClick={getHelp}>Help</button> : <></>}
                {logOut? <button className="button green-button" onClick={logOutCallback}>Log Out</button>: <></>}
            </div>
        </header>
    );
};

export default Header;